import {customElement, property} from 'lit/decorators.js';
import {FlywheelComponent} from '#lit/lib/component.js';
import {ImmutableComponent} from '#lit/components/mixins/immutable_component/index.js';
import type {Constructor} from '#lit/types/classes.js';
import type {LogsInspectorHandlers, Model} from './architecture.js';
import {Msg, main} from './architecture.js';
import styles from './style.scss';
import type {TemplateResult} from 'lit';

export const LOGS_INSPECTOR_MODAL_ELEMENT_TAG = 'logs-inspector-modal';

/**
 * A modal for displaying log messages
 */
@customElement(LOGS_INSPECTOR_MODAL_ELEMENT_TAG)
export default class LogsInspectorModal extends ImmutableComponent<
  Constructor<FlywheelComponent>,
  Model,
  Msg
>({component: FlywheelComponent, main}) {
  static get styles() {
    return [styles];
  }

  @property({type: String})
  get label() {
    return this.model.modal.label;
  }

  set label(value: string) {
    this.handleUpdate(Msg.setLabel(value));
  }

  @property({type: Object})
  set header(value: TemplateResult<1>) {
    this.handleUpdate(Msg.setHeader(value));
  }

  @property({type: Object})
  set handlers(value: LogsInspectorHandlers) {
    this.handleUpdate(Msg.setHandlers(value));
  }

  @property({type: Boolean})
  get open() {
    return this.model.modal.open;
  }

  set open(value: boolean) {
    this.handleUpdate(Msg.setOpen(value));
  }

  openModal() {
    this.handleUpdate(Msg.setOpen(true));
  }
}

declare global {
  interface HTMLElementTagNameMap {
    [LOGS_INSPECTOR_MODAL_ELEMENT_TAG]: LogsInspectorModal;
  }
}
